import { useState } from 'react';

import { useAppDispatch } from '@src/core/hooks';
import { setErrors } from '@src/features/customers/auth/store/auth';

import { LOGIN_MODE, type LoginMode } from '../types';

export function useLoginMode() {
  const dispatch = useAppDispatch();
  const [mode, setMode] = useState<LoginMode>(LOGIN_MODE.PASSWORD);

  const switchToOtp = () => {
    dispatch(setErrors('login', {}));
    dispatch(setErrors('otp', {}));
    setMode(LOGIN_MODE.OTP);
  };

  const switchToPassword = () => {
    dispatch(setErrors('otp', {}));
    dispatch(setErrors('login', {}));
    setMode(LOGIN_MODE.PASSWORD);
  };

  return { mode, switchToOtp, switchToPassword };
}
